module.exports = __webpack_public_path__ + "img/logo-fc-stream.46637555.svg";